import { render, staticRenderFns } from "./Wards.vue?vue&type=template&id=3f01292e&"
import script from "./Wards.vue?vue&type=script&lang=js&"
export * from "./Wards.vue?vue&type=script&lang=js&"
import style0 from "./Wards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports